<div class="modal-content">
  <apm-section-title icon="t_search" title="{{ '445220' | apmTranslate }}"></apm-section-title>
  <div class="d-flex gap-4 overflow-auto pb-2">
    @if (groupedClasses$ | async; as groupedClasses) {
      @for (group of groupedClasses | keyvalue; track group.key; let isLast = $last) {
        <div class="d-flex flex-column gap-2">
          @for (c of group.value; track c.id) {
            <apm-list-tile
              class="text-uppercase"
              [apmColorAccent]="c.id | classColor"
              [ngClass]="c.customClass"
              (listTileClick)="filterSelected(c)"
            >
              {{ c.description ? c.description : (c.descriptionId | apmTranslate) }}
            </apm-list-tile>
          }
          @if (custom && isLast) {
            <apm-list-tile [apmColorAccent]="'CUSTOM' | classColor" (listTileClick)="customSelected()">
              {{ '445221' | apmTranslate }}
            </apm-list-tile>
            <apm-list-tile [apmColorAccent]="'AHU_CUSTOM' | classColor" (listTileClick)="utaSelected()">
              {{ '445222' | apmTranslate }}
            </apm-list-tile>
          }
        </div>
      }
    }
  </div>
</div>
